import React, { useCallback, useEffect } from 'react';
import { useRouteError, useNavigate } from 'react-router-dom';
import Sentry from 'Sentry';

import ErrorLayout from 'components/ErrorLayout';

function SentryErrorBoundaryWrapper() {
  const navigate = useNavigate();
  const routeError = useRouteError();

  useEffect(() => {
    Sentry.captureException(routeError, { level: 'fatal' });
  }, [routeError]);

  const handleGoToHome = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <ErrorLayout
      title="Oh no! You Broke This, Contant The Tech Team Now!!"
      message="Please try again later"
      actionFn={handleGoToHome}
      actionLabel="Go To Home"
    />
  );
}

export default SentryErrorBoundaryWrapper;
